import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import ImgLogo from './img/Logo.webp';


export function AppDownloadModal({ show, onHide }) {

    function OpenAppStore() {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;

        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            window.open('https://apps.apple.com/kr/app/%EC%9D%B4%EC%8B%AC%EC%A0%84%EC%8B%AC-%EC%B7%A8%ED%96%A5-%EA%B6%81%ED%95%A9-%ED%85%8C%EC%8A%A4%ED%8A%B8/id1475848502', '_blank');
        } else {
            window.open('https://play.google.com/store/apps/details?id=com.bgrn3', '_blank');
        }
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="md"
            backdrop={true}
            backdropClassName="modal-backdrop-show"
            contentClassName="app-download-modal-content"
            style={{ zIndex: 1060 }}
        >
            <style>{`
                .app-download-modal-content {
                    border-radius: 45px !important;
                    border: none !important;
                }
            `}</style>
            <Modal.Body className='p-5'>
                <div className='d-flex flex-column justify-content-center align-items-center' style={{ minHeight: '300px' }}>
                    <div className='d-flex justify-content-center align-items-center mb-4'>
                        <div style={{
                            width: '120px',
                            height: '120px',
                            borderRadius: '24px',
                            boxShadow: '0 8px 24px rgba(255, 94, 0, 0.4)',
                            border: '2px solid rgba(255, 255, 255, 0.3)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '16px'
                        }}>
                            <img
                                src={ImgLogo}
                                alt='밸런스 게임 로고'
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>
                    </div>

                    <div className='w-100 mb-4'>
                        <div className='text-center mb-4'>
                            <div className='text-primary fs-4'><b>밸</b>런스게임으로 <b>궁</b>합보기</div>
                        </div>
                        <div className='d-flex flex-column gap-3 my-3 align-items-center'>
                            <div className='d-flex align-items-center'>
                                <span className='text-muted small'>친구 설치 필요 없어요. 🙅‍♂️ 나만 받으면 끝!</span>
                            </div>
                            <div className='d-flex align-items-center'>
                                <span className='text-muted small'>3명 이상 궁합? 👨‍👩‍👧 이 앱 하나로 해결!</span>
                            </div>
                            <div className='d-flex align-items-center'>
                                <span className='text-muted small'>질문 검색 그만 ✋ 핫한 질문만 추천!</span>
                            </div>
                        </div>
                    </div>

                    <div className='w-100 gap-3'>
                        <Button
                            variant="primary"
                            className='w-100 py-3 rounded-pill fw-bold d-flex align-items-center justify-content-center'
                            size='lg'
                            onClick={() => {
                                onHide();
                                OpenAppStore();
                            }}
                            style={{ color: 'white' }}
                        >
                            <span>밸궁 앱 다운받기</span>
                            <i className="fi-rr-download ms-2" style={{ fontSize: '18px' }}></i>
                        </Button>
                        <Button variant="" className='w-100 pt-3 align-items-center justify-content-center'
                            onClick={() => {
                                onHide();
                            }}
                        >
                            <span className='text-muted small'>다음에 받기</span>
                        </Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

